import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import moment from "moment";
import { PaginationLimit, usersStatus } from "../../Config";
import { IoMdEye } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { IoMdMore } from "react-icons/io";
import { Tooltip } from "react-tooltip";
import { MdFileUpload } from "react-icons/md";

const RecentUsedTable = ({
  apiData,
  setSelectedData,
  setViewDetail,
  setRentAgreement,
}) => {
  const [data, setData] = useState([
    {
      deviceName: "",
      extractionTime: "",
      processingTime: "",
      drops: "",
      action: "",
    },
  ]);

  const userStatusColor = (status) => {
    const colors = {
      Pending: "bg-yellow-100 text-yellow-700 border-yellow-200",
      Active: "bg-green-100 text-green-700 border-green-200",
      Inactive: "bg-blue-100 text-blue-700 border-blue-200",
      Suspended: "bg-red-100 text-red-700 border-red-200",
    };
    return colors[status] || "bg-gray-50 text-gray-700 border-gray-100";
  };
  const navigate = useNavigate();
  const [selectedRow, setSelectedRow] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const [currentPage, setCurrentPage] = useState(0);
  const [openActionMenu, setOpenActionMenu] = useState(null);
  const toggleRow = (index) => {
    setSelectedRow(selectedRow === index ? null : index);
  };

  const viewDetail = (item) => {
    setViewDetail(true);
    setSelectedData(item);
    setOpenActionMenu(null);
  };

  const rentagreement = (item) => {
    setRentAgreement(true);
    setSelectedData(item);
    setOpenActionMenu(null);
  };

  const goToInventories = (item) => {
    navigate(`/inventories/${item.id}`, { state: { name: item?.name } });
  };

  const ActionBtns = (item) => {
    const openMenu = (id) => {
      setOpenActionMenu((prevId) => {
        return prevId === id ? null : id;
      });
    };

    return (
      <ActionBtnWrapper>
        {openActionMenu === item.id && (
          <MenuOptions id="menuOptions">
            <MenuItem
              title="View Detail"
              onClick={(e) => {
                e.stopPropagation();
                viewDetail(item);
              }}
            >
              <IoMdEye className="text-gray-700 mr-2" /> View Detail
            </MenuItem>

            <MenuItem
              title="Upload Rent Agreement"
              onClick={(e) => {
                e.stopPropagation();
                rentagreement(item);
              }}
            >
              <MdFileUpload className="text-gray-700 mr-2" />
              Upload Rent Agreement
            </MenuItem>
          </MenuOptions>
        )}
        <Btn
          title="Actions"
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            openMenu(item.id);
          }}
        >
          <IoMdMore className="text-gray-600" size={24} />
        </Btn>
      </ActionBtnWrapper>
    );
  };

  useEffect(() => {
    if (apiData) {
      const tempData = apiData.map((item) => ({
        _original: item,
        name: getName(item),
        city: getCity(item),
        inventoryCount: getInventoryCount(item),
        lastLogin: getDate(item),
        status: getStatus(item.status),
        action: ActionBtns(item),
      }));
      setData(tempData);
    }
  }, [apiData, openActionMenu]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest("#menuOptions") &&
        !event.target.closest(".action-btn")
      ) {
        setOpenActionMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getName = (item) => {
    return (
      <div className="flex flex-col gap-[2px]">
        <p className="text-zinc-900 font-semibold cursor-pointer">
          {item.name}
        </p>
        <p className="text-amber-500 text-xs">#{item.mobile}</p>
      </div>
    );
  };

  const getCity = (item) => {
    if (!item.city) return "";
    const isLongCityName = item.city.length > 15;
    return (
      <div className="cursor-pointer">
        <div className="text-gray-500 font-medium text-sm">
          {item?.businessName || ""}
        </div>
        <a
          data-tooltip-id={`tooltip-city-${item.id || ""}`}
          data-tooltip-content={isLongCityName ? item.city : ""}
          data-tooltip-delay-show={1000}
          data-tooltip-place="top"
          data-tooltip-variant="info"
          className="max-w-[150px] text-gray-400 font-medium text-xs"
          href
        >
          {isLongCityName ? (
            <p className="cursor-pointer">
              {item.city.substring(0, 15) + "..."}
            </p>
          ) : (
            item.city || ""
          )}
        </a>
        <Tooltip id={`tooltip-city-${item.id}`} className="!w-60 sm:!w-80" />
      </div>
    );
  };

  const getInventoryCount = (item) => {
    const isClickable = item.inventoryCount > 0;
    if(item.inventoryCount === 0 && !item.inventoryCount){
      return(
        <div className="flex items-center gap-2">
          <span className="px-3 py-1.5 bg-neutral-100 hover:bg-neutral-200 text-sm font-medium text-gray-700 flex items-center gap-2 rounded-full transition">
          0
        </span>
        </div>
      )
    }
    return (
      <div className="flex items-center gap-2">
        <button
          onClick={() => isClickable && goToInventories(item)}
          className="px-3 py-1.5 bg-neutral-100 hover:bg-neutral-200 text-sm font-medium text-gray-700 flex items-center gap-2 rounded-full transition"
        >
          {item.inventoryCount}
        </button>
      </div>
    );
  };

  const getStatus = (status) => {
      const statusObj = usersStatus.find((item) => item.value === status);
  
      const label = statusObj?.label || "Unknown";
  
      return (
        <div
          className={`text-xs border w-24 h-7 flex items-center justify-center rounded-full ${userStatusColor(label)}`}
        >
          {label}
        </div>
      );
    };
  const getDate = (item) => {
    return (
      <div className="flex flex-col">
        <span className="">{moment(item.lastLogin).format("DD-MM-YYYY")}</span>
        <span className="text-gray-400 font-medium text-xs">
          {moment(item.lastLogin).format("hh:mm A")}
        </span>
      </div>
    );
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const columns = React.useMemo(() => {
    if (isMobileView) {
      // Display only "User" column for mobile screens
      return [
        {
          Header: "User Name",
          accessor: "name",
        },
        {
          Header: "Inventory",
          accessor: "inventoryCount",
        },
      ];
    }

    // Columns for larger screens
    return [
      {
        Header: "User Details",
        accessor: "name",
      },
      {
        Header: "City",
        accessor: "city",
      },
      {
        Header: "Inventory",
        accessor: "inventoryCount",
      },
      {
        Header: "Last Login",
        accessor: "lastLogin",
      },
      {
        Header: "Status",
        accessor: "status",
      },
      {
        Header: "Action",
        accessor: "action",
      },
    ];
  }, [isMobileView]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    pageOptions,
    page,
    state: { pageIndex, pageSize },
    previousPage,
    nextPage,
    setPageSize,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
    },
    useSortBy,
    usePagination,
  );

  useEffect(() => {
    setCurrentPage(pageIndex);
  }, [pageIndex]);
  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${
                          column.isSortedDesc ? "-rotate-90" : "rotate-90"
                        } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        {/* <Tbody {...getTableBodyProps()} hasdata={apiData?.length > 0}> */}
        <Tbody
          {...getTableBodyProps()}
          className={apiData?.length > 0 ? "border-b" : ""}
        >
          {page.map((row, rowIndex) => {
            prepareRow(row);
            return (
              <React.Fragment key={rowIndex}>
                {/* <Tr {...row.getRowProps()} hasdata={apiData?.length > 0}> */}
                <Tr
                  {...row.getRowProps()}
                  className={apiData?.length > 0 ? "border-b" : ""}
                >
                  {row.cells.map((cell, cellIndex) => {
                    return (
                      <Td
                        {...cell.getCellProps()}
                        onClick={() => {
                          if (
                            cellIndex === 0 ||
                            (cellIndex === 1 && window.innerWidth < 768)
                          ) {
                            toggleRow(rowIndex);
                          }
                        }}
                      >
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
                {selectedRow === rowIndex && window.innerWidth < 768 && (
                  <Tr>
                    <Td colSpan={columns.length}>
                      <ul className="flex flex-col gap-2">
                        <li>
                          <strong>City:</strong> {data[rowIndex].city}
                        </li>
                        <li>
                          <strong>Created At:</strong> {data[rowIndex].date}
                        </li>
                        <li className="flex gap-2">
                          <strong>Status:</strong> {data[rowIndex].status}
                        </li>
                        <li>
                          <strong>Action:</strong> {data[rowIndex].action}
                        </li>
                      </ul>
                    </Td>
                  </Tr>
                )}
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>
      {apiData?.length > 0 && (
        <PaginationWrapper>
          <div className="px-2">
            Page{" "}
            <em>
              {pageIndex + 1} of {pageOptions.length}
            </em>
          </div>
          <div className="flex gap-1">
            <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
            </PrevBtn>
            <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
              <img
                src={Images.Arrow}
                alt="arrow"
                className="w-2 rotate-180 opacity-75 "
              />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}
    </>
  );
};
const Btn = tw.button`action-btn grid place-items-center border border-gray-300 w-8 h-8 rounded-full transform transition duration-200 hover:scale-110 hover:shadow-md`;
const ActionBtnWrapper = tw.div`flex items-center gap-3 relative`;
const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-zinc-500 bg-slate-100`;
const Tbody = tw.tbody`${({ hasdata }) => (hasdata ? "border-b" : "")}`;
const Tr = tw.tr`${({ hasdata }) =>
  hasdata ? "border-b" : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-medium text-gray-500`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const Active = tw.div`bg-green-100 text-green-700 text-xs border-green-300 border w-24 h-7 flex items-center justify-center rounded-full`;
const Verified = tw.div`bg-teal-100 text-teal-700 text-xs border-teal-300 border w-24 h-7 flex items-center justify-center rounded-full`;
const Unverified = tw.div`bg-rose-100 text-rose-700 text-xs border-rose-300 border w-24 h-7 flex items-center justify-center rounded-full`;
const Enrolled = tw.div`bg-yellow-100 text-yellow-700 text-xs border-yellow-300 border w-24 h-7 flex items-center justify-center rounded-full`;
const MenuOptions = tw.div`absolute bottom-10 right-0 py-4 w-max bg-white z-50 rounded-lg shadow-lg border border-gray-200 flex flex-col`;
const MenuItem = tw.div`flex items-center gap-2 px-4 py-2 text-base font-medium cursor-pointer hover:bg-gray-100`;
export default RecentUsedTable;
